import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Cookies } from '../../index.js';
import { update_national_market } from '../../order/orders/actions.js';
import { useDispatch } from 'react-redux';
import { alert_error } from '../../AppContext';
import NationalMarketUI from './national_ui.jsx';
import { get_latest_version_text } from '../../js/latest_version.js';

export default function MarketSelector() {
  const dispatch = useDispatch();
  const [selectedChoice, setSelectedChoice] = useState(null);
  const [nutxuly, setnutxuly] = useState(0);
  const latestVersion = get_latest_version_text(Cookies.get('latest_version'));

  // 🔥 HÀM RIÊNG CHO RELOAD
  const processPage = () => {
    const redirectUri = Cookies.get('national_uri_change') || '/reactapp/';
    window.location.href = redirectUri;
  };

  useEffect(() => {
    const saved = Cookies.get('national_market');
    const apikey = Cookies.get('apikey');

    if (saved) {
      setSelectedChoice(saved);
      dispatch(update_national_market(saved));
    } else {
      const fetchMarket = async () => {
        try {
          const url = `https://hust.media/api/profile/national_market.php?apikey=${apikey}&service_national=get`;
          const response = await axios.get(url);
          const data = response.data;

          if (data.status == '1' && data.national_market) {
            const nm = data.national_market;
            Cookies.set('national_market', nm, { expires: 365 });
            dispatch(update_national_market(nm));
            processPage(); // dùng hàm reload
          } else {
              if (data.message && latestVersion !== '3') alert_error(data.message);
          }
        } catch (error) {
          alert_error('Error fetching national market:', error);
        }
      };
      fetchMarket();
    }
  }, [dispatch]);

  const confirmChoice = async () => {
    if (!selectedChoice) return;
    setnutxuly(1);

    try {
      const apikey = Cookies.get('apikey');

      if (!apikey) {
        Cookies.set('national_market', selectedChoice, { expires: 365 });
        dispatch(update_national_market(selectedChoice));
        processPage();
      } else {
        const url = `https://hust.media/api/profile/national_market.php?apikey=${apikey}&service_national=change&national_market=${selectedChoice}`;
        const response = await axios.get(url);
        const data = response.data;

        if (data.status == '1') {
          Cookies.set('national_market', selectedChoice, { expires: 365 });
          dispatch(update_national_market(selectedChoice));
          processPage();
        } else {
          if (data.message && latestVersion !== '3') alert_error(data.message);
        }
      }
    } catch (error) {
      alert_error('Error changing national market:', error);
    } finally {
      setnutxuly(0);
    }
  };

  return (
    <NationalMarketUI
      selected={selectedChoice}
      loading={nutxuly == 1}
      onSelect={setSelectedChoice}
      onConfirm={confirmChoice}
    />
  );
}
